import { configureStore } from "@reduxjs/toolkit";


import productsSliceReducer from "./slices/productsSlice"; 
import likedProductSliceReducer from "./slices/likedProductSlice"; 
import productsTypeSlice from "./slices/productsTypeSlice";
import userSliceReducer from "./slices/userSlice";
import shoppingCartSliceReducer from "./slices/shoppingCartSlice";
import commentsSliceReducer from "./slices/commentsSlice";
import locationReducer from './slices/locationSlice';
import curProductReducer from './slices/curProductSlice';
import searchReducer from "./slices/searchSlice";
import paydOrdersReducer from "./slices/paydOrderSlice";
import adminPaydOrdersReducer from "./slices/adminPaydOrdersSlice";

export const store = configureStore({
    reducer: {
        search: searchReducer,
        products: productsSliceReducer,
        curProduct: curProductReducer,
        productsType: productsTypeSlice,
        likedProduct: likedProductSliceReducer,
        location: locationReducer,
        comment: commentsSliceReducer,
        user: userSliceReducer,
        shoppingCart: shoppingCartSliceReducer,
        paydOrders: paydOrdersReducer,
        adminPaydOrders: adminPaydOrdersReducer,

    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
